import { appConstants } from "../helpers/constants";

const initialState = {
  loggedInData: null,
  isLoggedIn:false,
  currency: null,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case appConstants.UPDATE_LOGIN_STATUS:

      return {
        ...state,
        loggedInData: action.loggedInData,
        isLoggedIn: action.isLoggedIn,
        currency: action.currency,
      };
    case appConstants.REQUESTING_MONTLY_BUDGET:
      return {
        ...state,
        isLoading: true,
      };
    case appConstants.GET_MONTHLY_EXPENSE:
      return {
        ...state,
        monthlyExpenseList: action.monthlyExpenseList,
        totalBudget: action.totalBudget,
        totalSpent: action.totalSpent,
        totalIncome: action.totalIncome,
        isLoading: false,
      };
    case appConstants.GET_MONTHLY_INCOME:
      return {
        ...state,
        monthlyIncomeList: action.monthlyIncomeList,
        totalIncome: action.totalIncome,
        isLoading: false,
      };
    case appConstants.GET_MONTHLY_BUDGET_FAILED:
      return {
        ...state,
        isLoading: false,
      };
    case appConstants.UPDATE_USER_STATUS:
      return {
        ...state,
        // loggedInData: action.loggedInData,
        isLoggedIn: action.isLoggedIn,
        currency: action.currency,
        hideIncome: action.hideIncome,
      };
    case appConstants.UPDATE_CURRENCY:
      return {
        ...state,
        currency: action.currency,
      };
    case appConstants.UPDATE_USER_SETTINGS:
      return {
        ...state,
        hideIncome: action.hideIncome,
      };  

    // case DELETE_ITEM:
    //   return {
    //     ...state,
    //     numOfItems: state.numOfItems - 1,
    //   };
    default:
      return state;
  }
};

export default userReducer;
 